var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: { layout: _vm.layout, model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "试题内容：", prop: "topic" } },
            [
              _c("a-textarea", {
                attrs: {
                  placeholder: "请输入试题内容",
                  "auto-size": { minRows: 3, maxRows: 8 },
                },
                model: {
                  value: _vm.form.topic,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "topic", $$v)
                  },
                  expression: "form.topic",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "关联项：", prop: "relevance" } },
            [
              _c("a-select", {
                attrs: {
                  mode: "multiple",
                  placeholder: "请选择关联项",
                  options: _vm.relevanceOptions,
                },
                model: {
                  value: _vm.form.relevance,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "relevance", $$v)
                  },
                  expression: "form.relevance",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "判断类型：", prop: "judgmentType" } },
            [
              _c("a-select", {
                attrs: {
                  placeholder: "请选择判断类型",
                  options: _vm.judgmentTypeOptions,
                },
                on: { change: _vm.changeJudgmentType },
                model: {
                  value: _vm.form.judgmentType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "judgmentType", $$v)
                  },
                  expression: "form.judgmentType",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "计分方式：", prop: "judgmentType" } },
            [
              _c("a-select", {
                attrs: {
                  placeholder: "请选择计分方式",
                  options: _vm.scoringFormulaOptions,
                },
                on: { change: _vm.changeScoringFormula },
                model: {
                  value: _vm.form.scoringFormula,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "scoringFormula", $$v)
                  },
                  expression: "form.scoringFormula",
                },
              }),
            ],
            1
          ),
          _vm._l(_vm.form.topicOptions, function (item, index) {
            return _c(
              "a-form-model-item",
              {
                key: item.key,
                staticClass: "add-input",
                attrs: {
                  label: index === 0 ? "题目选项：" : "",
                  prop: "topicOptions." + index + ".value",
                  rules: {
                    required: true,
                    message: `题目选项${item.key}不能为空`,
                    trigger: "blur",
                  },
                },
              },
              [
                _c(
                  "a-input",
                  {
                    attrs: {
                      disabled: "",
                      "addon-before": item.key,
                      placeholder: "请输入",
                    },
                    model: {
                      value: item.value,
                      callback: function ($$v) {
                        _vm.$set(item, "value", $$v)
                      },
                      expression: "item.value",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { slot: "addonAfter" },
                        slot: "addonAfter",
                      },
                      [
                        _c("span", [_vm._v("分值：")]),
                        _c("a-input-number", {
                          staticStyle: { width: "71px" },
                          attrs: { disabled: "" },
                          on: {
                            change: function ($event) {
                              return _vm.changeeScore(item, index)
                            },
                          },
                          model: {
                            value: item.score,
                            callback: function ($$v) {
                              _vm.$set(item, "score", $$v)
                            },
                            expression: "item.score",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          _c(
            "a-form-model-item",
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("保存")]
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }